import styled, { keyframes } from 'styled-components';
import {
  brand,
  ink,
  surface,
  textSize,
  tones,
  touchTarget,
} from '../../../styles/brand';

export const Trigger = styled.button`
  position: relative;
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: ${tones.gray.text};
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  transition: background-color 0.15s ease;

  /* O círculo visível é pequeno para não pesar na linha; a área de toque
     chega a 44px. */
  &::after {
    content: '';
    position: absolute;
    inset: 50% auto auto 50%;
    width: ${touchTarget};
    height: ${touchTarget};
    transform: translate(-50%, -50%);
  }

  &[aria-expanded='true'] {
    background: ${tones.gray.soft};
    color: ${ink};
  }

  @media (hover: hover) {
    &:hover {
      background: ${tones.gray.soft};
      color: ${ink};
    }
  }

  &:focus-visible {
    outline: 2px solid ${brand.blue};
    outline-offset: 2px;
  }
`;

/* Cresce a partir do canto do gatilho, para ficar claro de onde veio. */
const growDown = keyframes`
  from { opacity: 0; transform: scale(0.96); }
`;

const growUp = keyframes`
  from { opacity: 0; transform: translateY(-100%) scale(0.96); }
`;

const fade = keyframes`
  from { opacity: 0; }
`;

export const Menu = styled.div<{ $above: boolean }>`
  position: fixed;
  z-index: 1500;
  min-width: 13rem;
  padding: 0.25rem;
  border-radius: 0.8rem;
  background: ${brand.white};
  border: 1px solid ${surface.line};
  box-shadow:
    0 10px 30px rgba(50, 50, 50, 0.14),
    0 2px 6px rgba(50, 50, 50, 0.06);
  transform: ${({ $above }) => ($above ? 'translateY(-100%)' : 'none')};
  transform-origin: ${({ $above }) => ($above ? 'bottom right' : 'top right')};
  animation: ${({ $above }) => ($above ? growUp : growDown)} 140ms
    cubic-bezier(0.32, 0.72, 0, 1);

  @media (prefers-reduced-motion: reduce) {
    animation: ${fade} 120ms ease;
  }
`;

export const Item = styled.button<{ $destructive: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: ${touchTarget};
  padding: 0 0.85rem;
  border: 0;
  border-radius: 0.55rem;
  background: transparent;
  text-align: left;
  white-space: nowrap;
  font-family: 'RedHatDisplay-Medium';
  font-size: ${textSize(0.9)};
  color: ${({ $destructive }) => ($destructive ? tones.red.text : ink)};
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;

  &:focus-visible {
    outline: none;
  }

  &:focus-visible,
  &:active {
    background: ${({ $destructive }) =>
      $destructive ? tones.red.soft : tones.gray.soft};
  }

  @media (hover: hover) {
    &:hover {
      background: ${({ $destructive }) =>
        $destructive ? tones.red.soft : tones.gray.soft};
    }
  }
`;

export const Separator = styled.hr`
  height: 1px;
  margin: 0.25rem 0.5rem;
  border: 0;
  background: ${surface.line};
`;
